(() => {
  if (window.__saKlaviyoContactOptinLoaded) return;
  window.__saKlaviyoContactOptinLoaded = true;

  const SELECTOR = '[data-sa-klaviyo-contact-optin]';

  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const subscribe = (checkbox, email) => {
    const companyId = checkbox.dataset.klaviyoCompanyId;
    const listId = checkbox.dataset.klaviyoListId;
    const source = checkbox.dataset.klaviyoSource || 'Camigoo contactformulier';

    if (!companyId || !listId) {
      return Promise.reject(new Error('Klaviyo contact opt-in is niet geconfigureerd.'));
    }

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                locale: document.documentElement.lang || 'nl-NL',
                properties: {
                  'Contactformulier bron': source,
                  'Contactformulier pagina': window.location.pathname,
                  'Nieuwsbrief toestemming': true,
                  'Nieuwsbrief toestemming op': new Date().toISOString()
                },
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return window.fetch(
      `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify(payload),
        keepalive: true
      }
    ).then((response) => {
      if (!response.ok) throw new Error(`Klaviyo contact subscription failed: ${response.status}`);
      return response;
    });
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((checkbox) => {
      const form = checkbox.form;
      if (!form || form.dataset.saKlaviyoContactOptinBound === 'true') return;
      form.dataset.saKlaviyoContactOptinBound = 'true';

      form.addEventListener('submit', (event) => {
        if (!checkbox.checked || form.dataset.saKlaviyoContactOptinSubmitting === 'true') return;

        const emailInput = form.querySelector('input[type="email"]');
        const email = emailInput ? emailInput.value.trim() : '';
        if (!validEmail(email)) return;

        event.preventDefault();
        form.dataset.saKlaviyoContactOptinSubmitting = 'true';

        const submitButton = event.submitter || form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        subscribe(checkbox, email)
          .catch((error) => {
            console.warn('[SmartAds] Contact opt-in kon niet naar Klaviyo worden verstuurd.', error);
          })
          .finally(() => {
            HTMLFormElement.prototype.submit.call(form);
          });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
